module.exports = __webpack_public_path__ + "static/marketing-video-91ab0bf83d17cf352fd652899bcebe37.gif";